const reviewsListSlider = document?.querySelectorAll('.reviews-list-slider');

reviewsListSlider?.forEach((item) => {
  const sliderEl = item?.querySelector('.keen-slider');

  const slider = new KeenSlider(sliderEl, {});
  const prevBtn = item?.querySelector('.slider-arrows .arrow-left');
  const nextBtn = item?.querySelector('.slider-arrows .arrow-right');
  nextBtn?.addEventListener('click', function () {
    slider?.next();
  });
  prevBtn?.addEventListener('click', function () {
    slider?.prev();
  });

  function handleResize() {
    if (window?.innerWidth <= 380) {
      slider.update({
        slides: { perView: 1, spacing: 20 },
      });
    } else if (window?.innerWidth <= 640) {
      slider.update({
        slides: { perView: window.innerWidth / 290, spacing: 20 },
      });
    } else if (window?.innerWidth <= 1040) {
      slider.update({
        slides: { perView: window.innerWidth / 250, spacing: 20 },
      });
    } else if (window?.innerWidth <= 1200) {
      slider.update({
        slides: { perView: window.innerWidth / 250, spacing: 20 },
      });
    } else {
      slider.update({
        slides: { perView: window.innerWidth / 275, spacing: 20 },
      });
    }
  }
  handleResize();
  window.addEventListener('resize', handleResize);
  window.addEventListener('load', handleResize);
});
